export const ButtonType = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  GHOST: 'GHOST',
};
